// Legacy solution level labels (for historical data)
const SOLUTION_LEVEL_LABELS = {
  "no-solution": "No Solution",
  "low-solution": "Low Solution",
  solution: "Full Solution",
};

// New GenAI assistance level labels (CSC113 scale)
const ASSISTANCE_LEVEL_LABELS = {
  1: "Level 1 - Idea Spark",
  2: "Level 2 - Code Check",
  3: "Level 3 - Debug Helper",
  4: "Level 4 - Co-Builder",
  5: "Level 5 - AI Only",
};

const SOLUTION_TYPE_LABELS = {
  concise: "Concise",
  "step-by-step": "Step-by-step",
  both: "Concise + Step-by-step",
};

const normalizeSolutionValue = (value = "") =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "-");

const formatModeLabel = (value = "", dictionary = {}) => {
  const normalized = normalizeSolutionValue(value);
  if (!normalized) {
    return "Not specified";
  }
  if (dictionary[normalized]) {
    return dictionary[normalized];
  }
  const fallback = normalized
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
  return fallback || "Not specified";
};

const formatSolutionLevelLabel = (value) =>
  formatModeLabel(value, SOLUTION_LEVEL_LABELS);
const formatSolutionTypeLabel = (value) =>
  formatModeLabel(value, SOLUTION_TYPE_LABELS);

// Format assistance level (new GenAI scale 1-5)
const formatAssistanceLevelLabel = (level) => {
  const numLevel = typeof level === "string" ? parseInt(level, 10) : level;
  return ASSISTANCE_LEVEL_LABELS[numLevel] || `Level ${numLevel}`;
};

export {
  formatModeLabel,
  formatSolutionLevelLabel,
  formatSolutionTypeLabel,
  formatAssistanceLevelLabel,
  normalizeSolutionValue,
  SOLUTION_LEVEL_LABELS,
  SOLUTION_TYPE_LABELS,
  ASSISTANCE_LEVEL_LABELS,
};
